import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class guideDocumentStore {

    // Properties

    @observable guideDocuments = [];
    @observable guideDocumentID = 0;

    @observable title = '';
    @observable url = '';

    @observable showUpdateGuideDocumentModal = false;
    @observable manageGuideDocumentTitle = '';
    @observable updateLoading = false;
    @observable readLoading = false;

    // Properties - Guest

    @observable guestGuideDocuments = [];
    @observable guestGuideDocumentsFilter = [];
    @observable searchByTitle = '';

    // Initialization

    @action initGuideDocument() {
        this.setShowUpdateGuideDocumentModal(false);

        return ApiCaller.GuideDocuments.apiGetGuideDocuments().then((guideDocumentResponses) => {
            if (guideDocumentResponses) {
                this.guideDocuments = guideDocumentResponses;
            } else {
                this.guideDocuments = [];
            }

            this.updateLoading = false;
        })
    }

    @action initGuestGuideDocument() {
        this.readLoading = true;
        this.searchByTitle = '';

        return ApiCaller.GuideDocuments.apiGetGuideDocuments().then((guideDocumentResponses) => {
            if (guideDocumentResponses) {
                this.guestGuideDocuments = guideDocumentResponses;
                this.guestGuideDocumentsFilter = this.guestGuideDocuments;
            } else {
                this.guestGuideDocuments = [];
                this.guestGuideDocumentsFilter = this.guestGuideDocuments;
            }

            this.readLoading = false;
        })
    }

    @action initCreate() {
        this.manageGuideDocumentTitle = 'Add Guide Document';

        this.guideDocumentID = 0;
        this.title = '';
        this.url = '';

        this.showUpdateGuideDocumentModal = true;
    }

    @action initUpdate(value) {
        this.guideDocumentID = value;
        this.manageGuideDocumentTitle = 'Update Guide Document'

        return ApiCaller.GuideDocuments.apiGetGuideDocumentsById(this.guideDocumentID).then((response) => {
            this.guideDocumentID = response.guideDocumentID;
            this.title = response.title;
            this.url = response.url;

            this.showUpdateGuideDocumentModal = true;
        })
    }

    @action initRead(id) {
        return ApiCaller.GuideDocuments.apiGetGuideDocumentsById(id).then((response) => {
            if (response) {
                this.guideDocumentID = response.guideDocumentID;
                this.title = response.title;
                this.url = response.url;
            }
        })
    }

    // Transaction

    @action createGuideDocument() {
        this.updateLoading = true;

        const guideDocument = {
            title: this.title,
            url: this.url
        };

        return ApiCaller.GuideDocuments.apiCreateGuideDocument(guideDocument).then(() => {
            this.initGuideDocument();
        });
    }

    @action updateGuideDocument() {
        this.updateLoading = true;
        const guideDocument = {
            guideDocumentID: this.guideDocumentID,
            title: this.title,
            url: this.url
        };

        return ApiCaller.GuideDocuments.apiUpdateGuideDocument(this.guideDocumentID, guideDocument).then(() => {
            this.initGuideDocument();
        });
    }

    @action deleteGuideDocument(guideDocumentID) {
        return ApiCaller.GuideDocuments.apiDeleteGuideDocument(guideDocumentID).then(() => {
            this.initGuideDocument();
        });
    }

    @action setTitle(value) {
        this.title = value;
    }

    @action setUrl(value) {
        this.url = value;
    }

    @action setSearchByTitle(value) {
        this.searchByTitle = value;

        if (value === '') {
            this.guestGuideDocumentsFilter = this.guestGuideDocuments;
        } else {
            this.guestGuideDocumentsFilter = this.guestGuideDocumentsFilter.filter(item => {
                let title = item.title.toLowerCase();
                return title.indexOf(value.toLowerCase()) !== -1;
            });
        }
    }

    @action setShowUpdateGuideDocumentModal(value) { 
        this.showUpdateGuideDocumentModal = value;
    }
    
}

export default new guideDocumentStore()